<div *ngIf="failed" class="loading-recovery" [dir]="globalService.isRTL ? 'rtl' : 'ltr'">
    <app-user-message type="error" [title]="(timedOut ? 'TAKING_LONG_HOME' : 'ACTION_NEEDED') | translate"
        [message]="'CHECK_YOUR_CONNECTION_AND_TRY_AGAIN' | translate" [dismissible]="false"
        [actionLabel]="'REFRESH' | translate" (action)="reload()"></app-user-message>
</div>
<div *ngIf="DontShow == false && !failed" class="loading-screen text-center" role="status" [attr.aria-label]="'LOADING_CHURCH_SERVICES' | translate">
    <div class="church-loader" aria-hidden="true">
        <span class="church-loader__ring"></span>
        <span class="church-loader__accent"></span>
        <img *ngIf="logoSource" class="church-loader__logo" [src]="logoSource" alt="" (error)="onLogoError()" />
        <span *ngIf="!logoSource" class="church-loader__fallback">✝</span>
    </div>
    <div class="loading-screen__message">
        <span [class.SmallArabicFont]="globalService.isRTL">{{ 'LOADING_CHURCH_SERVICES' | translate }}</span>
    </div>
</div>
